module.exports = __webpack_public_path__ + "img/female-infant-foot.f7f7029d.svg";